export const PAYCHECKS = 'PAYCHECKS';
export const SHOW_PAYCHECK = 'SHOW_PAYCHECK';
export const CREATE_PAYCHECK = 'CREATE_PAYCHECK';
export const SEARCH_PAYCHECKS = 'SEARCH_PAYCHECKS';



// WEBPACK FOOTER //
// ./src/actions/paychecks/actionTypes.js